









































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GET_PRODUCT } from '@/queries/Product';
import { SmartQuery } from 'vue-apollo-decorator';
import { ACTIVE_VAT_RATES } from '@/queries/ClientQueries';
import { GQL_unitInvoiceSetting, GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting } from '@/queries/__generated__/unitInvoiceSetting';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_activeNorwegianVatRates, GQL_activeNorwegianVatRates_activeNorwegianVatRates } from '@/queries/__client__/activeNorwegianVatRates';

@Component
export default class ProductShow extends Vue {
  @SmartQuery<ProductShow, GQL_activeNorwegianVatRates, { date: string }>({
    query: ACTIVE_VAT_RATES,
    variables() {
      return { date: this.today };
    },
  }) public activeNorwegianVatRatesMap!: Map<string, GQL_activeNorwegianVatRates_activeNorwegianVatRates>;

  @SmartQuery<ProductShow, GQL_unitInvoiceSetting>({
    query: UNIT_INVOICE_SETTINGS,
    update: data => data.currentUnit.unitSetting.unitInvoiceSetting,
  }) private unitInvoiceSetting!: GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting;

  public GET_PRODUCT = GET_PRODUCT;
  @Prop(String) public id!: string;

  public today = this.$dayjs().format('YYYY-MM-DD');

  public vatRateDisplay(symbol: string) {
    const vatRate = this.activeNorwegianVatRatesMap.get(symbol);
    if (!vatRate) return `?`;
    return this.$t(
      `VatRates.WithRate.${vatRate.symbol}`,
      { rate: vatRate.rate },
    );
  }
}
